import {toDate} from 'data/converter';

export const today = toDate(new Date());
export const FAST_FILTER_DEFAULT = {
  filter: {
    type: 'FAST_FILTER_DEFAULT',
    finRequestStateId: '2',
    finRequestTypeId: '2',
  },
  sort: {
    by: 'nextMonitoringDate',
    desc: false
  }
};

export const FAST_FILTER_UPDATED_TODAY = {
  filter: {
    type: 'FAST_FILTER_UPDATED_TODAY',
    lastChangeDate: {
      eq: today
    }
  },
  sort: {
    by: 'nextMonitoringDate',
    desc: false
  }
};

export const FAST_FILTER_MONITORING = {
  filter: {
    type: 'FAST_FILTER_MONITORING',
    isExpiration: true,
    finRequestStateId: '2'
  },
  sort: {
    by: 'nextMonitoringDate',
    desc: false
  }
};



// WEBPACK FOOTER //
// ./src/components/page/CollectionCase/fastFilters.js